import * as React from "react";
import { DateField, TextField, EditButton, TextInput, Button } from "react-admin";
import { List, Datagrid, IfCanAccess } from "src/enterprise/ra-rbac";
import SubjectIcon from "@mui/icons-material/Subject";
import { ItemsButton } from './';

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];

export const NavigationList = props => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="status" />
        <DateField source="created_at" label="Created At" />
        <ItemsButton />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
